<template>
  <a-card :bordered="false" :bodyStyle='{paddingTop:"0px"}'>
    <a-tabs v-model:activeKey="search.type" @change='tabChange'>
      <a-tab-pane :key="1" tab="经销商" :disabled='listLoading'></a-tab-pane>
      <a-tab-pane :key="2" tab="门店" :disabled='listLoading'></a-tab-pane>
    </a-tabs>
    <a-form class="m-b-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange'
      layout='inline'>
      <a-form-item :label="search.type == 1 ? '经销商名称':'门店名称'" name='name'>
        <a-input style="width: 270px" v-model:value="search.name" placeholder="请输入关键词进行搜索" />
      </a-form-item>
      <!-- <a-form-item label="库存状态" name='status'>
        <a-select v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">库存正常</a-select-option>
          <a-select-option :value="2">有商品即将售罄</a-select-option>
        </a-select>
      </a-form-item> -->
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>

      <a-form-item v-if='search.type == 2'>
        <a-button v-has:antiStockChannelExport="exportTable">导出</a-button>
        <a-button v-has:antiStockChannelExport="detailedExportTable" class="m-l-20">明细导出</a-button>
      </a-form-item>
      <a-form-item v-if='search.type == 1'>
          <a-button v-has:antiStockChannelExport="detailedExportTable">明细导出</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='name' :columns='columns' :data-source='list'>
      <template #title_name>
        {{search.type == 1 ? '经销商名称':'门店名称'}}
      </template>
      <template #title_level>
        {{search.type == 1 ? '经销商级别':'门店级别'}}
      </template>
      <template #title_status>
        {{search.type == 1 ? '经销商状态':'门店状态'}}
      </template>
      <template v-slot:action="{ record }">
        <a v-has:antiStockChannelDetail="()=> {$router.push('/antiFleeingGoods/inventoryReport/channelDetails?type='+search.type+'&num='+record.product_num+'&name='+record.name+'&id='+record.store_id)}"
          href="javascript:;">查看详情</a>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
      :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
</template>
<script>
  import { ref, onMounted, inject  } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { iscode } from "@/utils/app";
  import useTableSearch from "@/hooks/useTableSearch";
  import { getStockDealer,getStockStore } from "@/api/antiFleeing";
  import config from '@/config'
  // 初始化默认筛选项数值
  let defSearch = {
    type:1,
    status: '',
    page: 1,
    limit: 10,
    name: "",
  };
  export default {
    components: {},
    setup() {
      let columns = [
        {
          dataIndex: "name",
          key: "name",
          slots: { title: 'title_name' }
        },
        {
          dataIndex: "level",
          key: "level",
          slots: { title: 'title_level'}
        },
        {
          title: "所属上级",
          dataIndex: "parent_name",
          key: "parent_name",
        },
        {
          dataIndex: "status_text",
          key: "status_text",
          slots: { title: 'title_status'}
        },
        {
          title: "库存数量",
          dataIndex: "product_num",
          key: "product_num",
        },
        // {
        //   title: "库存状态",
        //   dataIndex: "product_num_status_text",
        //   key: "product_num_status_text",
        // },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject("$router");
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
      };
      const tabChange = () =>{
        tableHoosks.initData(search.value.type == 1 ? getStockDealer : getStockStore, search.value);
      }
      //导出
      const exportTable=async ()=>{
        const hide = message.loading('正在加载中...', 0);
        let result = await getStockStore({...search.value,excel:1}).then(res=>res.data).catch(error=>error);
        if(iscode(result,true)){
          window.open(config.onlineOrderUrl[process.env.VUE_APP_type]+'download?key='+result.data.key)
        }
        setTimeout(hide);
      }
      
      const detailedExportTable = async ()=>{
        const hide = message.loading('正在加载中...', 0);
           let result=null;
           if(search.value.type==1){ //经
            result = await getStockDealer({...search.value,excel:2}).then(res=>res.data)
           }else{ //门
              result = await getStockStore({...search.value,excel:2}).then(res=>res.data)
           }
            if(iscode(result,true)){
            window.open(config.onlineOrderUrl[process.env.VUE_APP_type]+'download?key='+result.data.key)
            }
            setTimeout(hide);
      }

      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        tableHoosks.initData(search.value.type == 1 ? getStockDealer : getStockStore, search.value);
      });
      return {
        ...tableHoosks,
        columns,
        tabChange,
        exportTable,
        detailedExportTable
      };
    },
  };
</script>